// 预览模块
export default {
    Preview: {
        ExitPreview: '退出预览',
        Tip: '提示：当前为预览页面，答题不被记录',
        MobilePhone: '手机',
        Computer: '电脑',
        ReferenceThisTemplate: '引用该模板',
        InReference: '引用中'
    },
  };